import { render } from "./AppPage.vue?vue&type=template&id=09c55862&scoped=true"
import script from "./AppPage.vue?vue&type=script&lang=js"
export * from "./AppPage.vue?vue&type=script&lang=js"

import "./AppPage.vue?vue&type=style&index=0&id=09c55862&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c55862"]])

export default __exports__